function isAllowedTemplate() {
  const t = window.__shopifyTemplate;
  return t === 'collection' || t === 'index' || t === 'list-collections';
}

function findGrid() {
  if (!isAllowedTemplate()) return null;
  return document.getElementById('product-grid')
    || document.querySelector('.product-grid');
}

let savedSizes = null;
let lastWidth = null;

function generateSizes(cards, W) {
  const isMobile = W < 600;
  const GAP = isMobile ? 6 : 8;
  const maxBase = isMobile ? W * 0.40 : 280;  // 0.65 → 0.40
  const minBase = isMobile ? W * 0.20 : 80;
const maxAllowedW = Math.floor((W - GAP * 2) / 3);

  return cards.map(card => {
    const img = card.querySelector('img');
    let aspect = 1;
    if (img && img.naturalWidth && img.naturalHeight) {
      aspect = img.naturalWidth / img.naturalHeight;
    }

    const base = minBase + Math.random() * (maxBase - minBase);
    let w = Math.round(base * aspect);
    let h = Math.round(base);

    if (w > maxAllowedW) {
      const scale = maxAllowedW / w;
      w = Math.round(w * scale);
      h = Math.round(h * scale);
    }

    return { card, w, h };
  });
}

function shuffleArray(arr) {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

function isMonotonic(arr) {
  if (arr.length <= 2) return false;
  const areas = arr.map(s => s.w * s.h);
  let increasing = true;
  let decreasing = true;
  for (let i = 1; i < areas.length; i++) {
    if (areas[i] <= areas[i - 1]) increasing = false;
    if (areas[i] >= areas[i - 1]) decreasing = false;
  }
  return increasing || decreasing;
}

function shuffleNonMonotonic(sizes) {
  let result = shuffleArray(sizes);
  let attempts = 0;
  while (isMonotonic(result) && attempts < 20) {
    result = shuffleArray(sizes);
    attempts++;
  }
  return result;
}

function layout(sizes, W) {
  const isMobile = W < 600;
  const GAP = isMobile ? 6 : 8;
  const available = sizes.filter(function(s) {
  var badge = s.card.querySelector('.badge');
  return !badge || badge.textContent.trim().toLowerCase() !== 'sold out';
});
const soldOut = sizes.filter(function(s) {
  var badge = s.card.querySelector('.badge');
  return badge && badge.textContent.trim().toLowerCase() === 'sold out';
});
const sorted = shuffleNonMonotonic(available).concat(shuffleNonMonotonic(soldOut));

  let shelfY = 0, shelfH = 0, x = 0;
  sorted.forEach(s => {
    let w = Math.min(s.w, W);
    if (x > 0 && x + w > W) { shelfY += shelfH + GAP; x = 0; shelfH = 0; }

    s.card.style.setProperty('position', 'absolute', 'important');
    s.card.style.setProperty('left', x + 'px', 'important');
    s.card.style.setProperty('top', shelfY + 'px', 'important');
    s.card.style.setProperty('width', w + 'px', 'important');
    s.card.style.setProperty('height', s.h + 'px', 'important');
    s.card.style.setProperty('margin', '0', 'important');
    s.card.style.setProperty('overflow', 'hidden', 'important');

    x += w + GAP;
    shelfH = Math.max(shelfH, s.h);
  });

  return shelfY + shelfH;
}

function packProducts() {
  const container = findGrid();
  if (!container) return;

  const W = container.clientWidth;
  
  if (!W) return;

  if (lastWidth !== null && Math.abs(W - lastWidth) < 5) return;
  lastWidth = W;

  const cards = Array.from(container.children).filter(function (el) {
    return el.nodeType === 1 && getComputedStyle(el).display !== 'none';
  });


  
  if (cards.length === 0) return;

  if (!savedSizes || savedSizes.length !== cards.length) {
    savedSizes = generateSizes(cards, W);
  }

  const totalHeight = layout(savedSizes, W);

  container.style.position = 'relative';
  container.style.height = totalHeight + 'px';
  container.style.listStyle = 'none';
  container.style.display = 'block';
}
function init() {
  packProducts();
  
  setTimeout(function() {
    savedSizes = null;
    lastWidth = null;  // 가드 우회 → 강제 재배치
    packProducts();
  }, 200);
}

if (document.readyState === 'complete') {
  init();
} else {
  window.addEventListener('load', init);
}
window.addEventListener('resize', packProducts);

document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.sort-tab');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      var filter = tab.getAttribute('data-filter');
      var grid = findGrid();
      if (!grid) return;

      Array.from(grid.children).forEach(function (card) {
        var wrapper = card.querySelector('.card-wrapper') || card;
        var tags = (wrapper.getAttribute('data-tags') || '').split(',');
        var show = filter === 'all' || tags.indexOf(filter) !== -1;
        card.style.display = show ? '' : 'none';
      });

      savedSizes = null;
      lastWidth = null;
      packProducts();
    });
  });
});